import { ApiError } from './api-error';

export class BadRequestError extends ApiError {}
